export default {
  'notifications.subject': 'Subject',
  'notifications.message': 'Message',
  'notifications.sentAt': 'Sent At',
  'notifications.seeAll': 'See all notifications',
  'notifications.noNew': 'No new notifications',
};
